export function IconCharts() {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12">
            <path fill="currentColor" fillRule="evenodd" d="M7 0a2 2 0 0 0-2 2v1.5H2a2 2 0 0 0-2 2V10a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H7zm0 1.5a.5.5 0 0 0-.5.5v8.5H10a.5.5 0 0 0 .5-.5V2a.5.5 0 0 0-.5-.5H7zm-2 9V5H2a.5.5 0 0 0-.5.5V10a.5.5 0 0 0 .5.5h3z"/>
        </svg>
    );
}
